import 'react-datepicker/dist/react-datepicker.css'
import React, { useState, useEffect, forwardRef } from 'react'
import {
  Box,
  BoxProps,
  Flex,
  VStack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react'
import Picker from 'react-datepicker'
import { ChevronDownIcon, CloseIcon } from '@chakra-ui/icons'

type DateRange = [Date | null, Date | null]

interface IProps extends BoxProps {
  label?: string
  placeholder?: string
  reset?: boolean
  handleChange?: (dateRange: DateRange) => void
  defaultValue?: DateRange
}

export function DateRangePicker({
  children,
  label,
  placeholder,
  reset,
  handleChange,
  defaultValue,
  ...rest
}: IProps) {
  const [dateRange, setDateRange] = useState<DateRange>([
    null,
    null,
  ])
  const [startDate, endDate] = dateRange

  useEffect(() => {
    if (reset) {
      setDateRange([null, null])
    }
  }, [reset])

  const onChange = (update: DateRange) => {
    setDateRange(update)
  }

  const handleFilter = () => {
    if (handleChange) {
      handleChange(dateRange)
    }
  }

  useEffect(() => {
    if (defaultValue) {
      setDateRange(defaultValue)
    }
  }, [defaultValue])

  // eslint-disable-next-line react/display-name
  const CustomInput = forwardRef(({ value, onClick }: any, ref) => (
    <VStack alignItems="flex-start" width="100%" onClick={onClick}>
      <Text fontSize="xs" color="gray.850" lineHeight="18px">
        {label}
      </Text>
      <Flex
        cursor="pointer"
        bg={useColorModeValue('white', 'black.100')}
        height={{ base: '30px', md: '48px' }}
        width="100%"
        border="1px solid"
        borderColor="gray.470"
        borderRadius="8px"
        textAlign="left"
        fontWeight="normal"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        {...rest}
      >
        <Text fontSize={{ base: 'base', md: 'sm' }} ml={{ base: 2, md: 0 }} mr={2}>
          {value ? value : placeholder}
        </Text>
        {value ? (
          <Box
            onClick={() => onChange([null, null])}
            cursor="pointer"
            bg="brand.600"
            color="white"
            borderRadius="full"
            boxSize="15px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CloseIcon boxSize="5px" />
          </Box>
        ) : (
          <ChevronDownIcon />
        )}
      </Flex>
    </VStack>
  ))

  return (
    <Box
      css={{
        '.react-datepicker-wrapper': {
          display: 'flex',
        },
      }}
      {...rest}
    >
      <Picker
        selected={startDate}
        onChange={onChange}
        onCalendarClose={handleFilter}
        startDate={startDate}
        endDate={endDate}
        selectsRange
        customInput={<CustomInput />}
      />
    </Box>
  )
}
